import { render, staticRenderFns } from "./AccessibleInput.vue?vue&type=template&id=4fb8fde3"
import script from "./AccessibleInput.vue?vue&type=script&lang=js"
export * from "./AccessibleInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports